import { render } from "./ServicesTwoPage.vue?vue&type=template&id=ce26fe7e"
import script from "./ServicesTwoPage.vue?vue&type=script&lang=js"
export * from "./ServicesTwoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__